export default __webpack_public_path__ + "static/media/ManuelaLovelace.b9668985.png";